// Shared components for linking person names/avatars to their public profile.
// Pass `username` null/undefined to get a non-link render — the APIs that
// feed these widgets always return `null` for users without a reserved handle.
//
// Keep the hover affordance subtle (underline on hover, violet accent) so
// dense feeds don't become a sea of underlines.
import { Link } from "react-router-dom";

export const LinkedName = ({
  username,
  name,
  children,
  className = "",
  stopPropagation = true,
  testId,
}) => {
  const handleClick = stopPropagation ? (e) => e.stopPropagation() : undefined;
  if (!username) {
    return <span className={className}>{children ?? name}</span>;
  }
  return (
    <Link
      to={`/${username}`}
      onClick={handleClick}
      className={`${className} hover:underline decoration-violet-400 underline-offset-2 transition-colors`}
      data-testid={testId || `profile-link-${username}`}
    >
      {children ?? name}
    </Link>
  );
};

// Wraps an <Avatar> (or any avatar-shaped child) with a profile link.
// Keeps the shape exactly — the link has no visual styling of its own.
export const LinkedAvatar = ({
  username,
  children,
  className = "",
  stopPropagation = true,
  testId,
  style,
}) => {
  const handleClick = stopPropagation ? (e) => e.stopPropagation() : undefined;
  if (!username) {
    return <div className={className} style={style}>{children}</div>;
  }
  return (
    <Link
      to={`/${username}`}
      onClick={handleClick}
      className={`${className} block`}
      style={style}
      data-testid={testId || `profile-avatar-link-${username}`}
    >
      {children}
    </Link>
  );
};
